import SlideoutMenu from '@orn/shared-web/components/SlideoutMenu';
import { RecurringIcon } from '@orn/shared-web/icons';

interface IIsRecurringRowProps {
  /** @default true */
  isRecurring?: boolean;
}

const IsRecurringRow = ({ isRecurring = true }: IIsRecurringRowProps) => {
  if (!isRecurring) {
    return null;
  }

  return (
    <SlideoutMenu.Row icon={<RecurringIcon className="size-4.5 shrink-0" />} title="Recurring">
      <div className="text-primary text-md font-medium">Yes</div>
    </SlideoutMenu.Row>
  );
};

export default IsRecurringRow;
